<div class="progress-container-score">
    <svg viewBox="0 0 120 120">
        <g>
            <path
                *ngFor="let zone of zones"
                [attr.d]="getArcPath(zone.from, zone.to)"
                fill="none"
                [attr.stroke]="zone.color"
                [attr.stroke-width]="backgroundStrokeWidth"
            />
        </g>

        <circle
            class="progress-bar"
            cx="60"
            cy="60"
            [attr.r]="progressRadius"
            fill="none"
            [attr.stroke]="progressColor"
            [attr.stroke-width]="progressStrokeWidth"
            [style.strokeDasharray]="circumference"
            [style.strokeDashoffset]="strokeDashoffset"
            stroke-linecap="butt"
        />
    </svg>

    <div class="progress-text">
        <span class="percentage">{{ percentage.toFixed(1) }}</span>
        <span class="label" [style.color]="labelColor">{{ label }}</span>
    </div>
</div>